import { StyleSheet, Platform } from 'react-native'

import { Fonts, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: {
    paddingTop: 35,
    marginHorizontal: 16,
  },
  title: (theme = LightThemeColors) => ({
    color: theme.colors.textColor,
    fontSize: Platform.OS === 'ios' ? 25 : 24,
    fontFamily: Fonts.type.VodafoneLt,
    marginBottom: 30,
  }),
  cardsScroller: withTray => ({
    paddingBottom: withTray ? 130 : 80,
  }),
})
